// Dev/preview-only filter to silence known external iframe postMessage origin noise
// We do NOT hide real app errors; only suppress the exact, known noisy messages.

const shouldSilence = (msg: string) => {
  if (!msg) return false;
  // Suppress the known, benign cross-origin postMessage origin-mismatch noise
  // emitted by embedded third-party iframes (e.g. map widgets). Real app errors
  // are not affected.
  return msg.includes("Failed to execute 'postMessage' on 'DOMWindow': The target origin provided");
};

(() => {
  if (typeof window === 'undefined') return;

  // Error event listener
  window.addEventListener(
    'error',
    (e: ErrorEvent) => {
      const msg = e.message || (e.error && (e.error as any).message) || '';
      if (typeof msg === 'string' && shouldSilence(msg)) {
        e.preventDefault();
      }
    },
    true
  );

  // onerror fallback
  const prevOnError = window.onerror;
  window.onerror = function (message: any, source?: string, lineno?: number, colno?: number, error?: any) {
    const msg = typeof message === 'string' ? message : (error && error.message) || '';
    if (shouldSilence(msg)) {
      return true; // prevent logging
    }
    if (typeof prevOnError === 'function') {
      return prevOnError.apply(window, [message, source, lineno, colno, error]);
    }
    return false;
  };

  // Guard console.error to filter duplicates while preserving others
  const origError = console.error;
  console.error = (...args: any[]) => {
    try {
      const first = args[0];
      const msg = typeof first === 'string' ? first : (first && first.message) || '';
      if (shouldSilence(msg)) return;
    } catch {}
    origError.apply(console, args as any);
  };
})();
